<template>
    <div>
      <!--
      <div class="top-catalog-page__slider-wrap">
          <div class="top-catalog-page__slider swiper">
              <div class="top-catalog-page__wrapper swiper-wrapper">
                  <div class="top-catalog-page__slide swiper-slide">
                      <div class="checkbox">
                          <input
                              type="checkbox"
                              id="c_all"
                              class="checkbox__input"
                              value="1"
                              v-model="isAllChecked"
                          >
                          <label
                              for="c_all"
                              class="checkbox__label"
                          >
                              <span class="checkbox__text">
                                  {{ 'All' | trans }} ({{ totalPropertiesNumber }})
                              </span>
                          </label>
                      </div>
                  </div>
                  <div
                      v-for="propertyType in propertyTypes"
                      class="top-catalog-page__slide swiper-slide"
                      :key="propertyType.id"
                  >
                      <div class="checkbox">
                          <input
                              type="checkbox"
                              :id="'c_' + propertyType.id"
                              class="checkbox__input"
                              :value="propertyType"
                              v-model="localSelectedPropertyTypes"
                          >
                          <label
                              :for="'c_' + propertyType.id"
                              class="checkbox__label"
                          >
                              <span class="checkbox__text">
                                  {{ propertyType.title }} ({{ propertyType.properties_count | formatNumber }})
                              </span>
                          </label>
                      </div>
                  </div>
              </div>
          </div>
          <div class="catalog-button_prev _icon-slider_arr-left"></div>
          <div class="catalog-button_next _icon-slider_arr-right"></div>
      </div>
      -->
        <div class="top-catalog-page__info info-top-catalog">
            <div class="info-top-catalog__left">
                <span>
                    {{ 'Sorting' | trans }}:
                </span>
                <button type="button" data-popup=".popup-filter" class="info-top-catalog__btn">
                    {{ sortingText | trans }}
                </button>
            </div>
            <div class="info-top-catalog__right">
                <span>
                    {{ 'Showing:' | trans }}
                </span>
                <p>
                    {{ numbering }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import Swiper, {Navigation, FreeMode} from "swiper";

export default {
    name: "PropertiesPageFilter",
    props: {
        numbering: {
            type: String,
            required: true
        },
        totalPropertiesNumber: {
            type: Number,
            required: true
        },
        propertyTypes: {
            type: Array,
            required: true
        },
    },
    data() {
        return {
            localSelectedPropertyTypes: [],
            allowToRedirectPage: false,
        };
    },
    computed: {
        ...mapGetters({
            selectedPropertyTypesFromStore: 'filtration/selectedPropertyTypes',
            selectedHighestPriceFromStore: 'filtration/selectedHighestPrice',
            selectedLowestPriceFromStore: 'filtration/selectedLowestPrice',
            selectedIsNewFromStore: 'filtration/selectedIsNew',
            selectedIsPopularFromStore: 'filtration/selectedIsPopular',
        }),
        isAllChecked: {
            get() {
                return this.localSelectedPropertyTypes.length === 0;
            },
            set(value) {
                if (value && this.localSelectedPropertyTypes.length !== 0) {
                    this.localSelectedPropertyTypes = [];
                }
            }
        },
        sortingText() {
            if (this.selectedIsPopularFromStore) {
                return 'by popularity';
            } else if (this.selectedHighestPriceFromStore) {
                return 'Highest price';
            } else if (this.selectedLowestPriceFromStore) {
                return 'Lowest price';
            } else if (this.selectedIsNewFromStore) {
                return 'new';
            }
        }
    },
    methods: {
        ...mapActions({
            updateSelectedPropertyTypes: 'filtration/updateSelectedPropertyTypes',
            redirectToPropertiesPage: 'filtration/redirectToPropertiesPage',
            resetFiltrationParams: 'filtration/resetFiltrationParams',
            saveToLocalStorage: 'filtration/saveToLocalStorage',
        }),
        updateSelectedTypes() {
            const params = {
                selectedPropertyTypes: this.localSelectedPropertyTypes
            };
            this.updateSelectedPropertyTypes(params);
            if (this.allowToRedirectPage) {
                this.redirectToPropertiesPage();
            }
        },
    },
    watch: {
        localSelectedPropertyTypes: {
            handler(newVal, oldVal) {
                if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
                    this.updateSelectedTypes();
                }
                this.allowToRedirectPage = true;
            },
            deep: true
        },
    },
    mounted() {
        let resetFilter = new URLSearchParams(window.location.search).get('resetFilter');
        if (resetFilter) {
            this.resetFiltrationParams();
            this.saveToLocalStorage();

            let propertyTypesIds = new URLSearchParams(window.location.search).get('propertyTypesIds');
            if (!propertyTypesIds) propertyTypesIds = '[]';

            propertyTypesIds = JSON.parse(propertyTypesIds).map(num => ({id: num}));
            this.updateSelectedPropertyTypes({
                'selectedPropertyTypes': propertyTypesIds
            });
        }

        this.localSelectedPropertyTypes = this.propertyTypes.filter(type =>
            this.selectedPropertyTypesFromStore.some(selectedType => selectedType.id === type.id)
        );
        if (!!this.propertyTypes && document.querySelector(".top-catalog-page__slider")) {
            new Swiper(".top-catalog-page__slider", {
                modules: [Navigation, FreeMode],
                observer: true,
                observeParents: true,
                speed: 800,
                spaceBetween: 10,
                watchOverflow: true,
                freeMode: true,
                slidesPerView: "auto",
                breakpoints: {
                    768: {
                        navigation: {
                            prevEl: ".catalog-button_prev",
                            nextEl: ".catalog-button_next"
                        }
                    }
                },
                on: {}
            });
        }
    },
}
</script>
